(() => {
  if (customElements.get('momo-newsletter-popup')) return;
  class MomoNewsletterPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.dialog || !this.form || typeof this.dialog.showModal !== 'function') return;
      this.key = 'momo-newsletter-v1';
      this.state = this.querySelector('[data-newsletter-state]').dataset.newsletterState;
      this.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('momo-newsletter-open');
        this.write('sessionStorage', 'dismissed', '1');
      });
      // Keep Shopify's normal submit, spam protection, and browser validation intact.
      this.form.addEventListener('submit', () => this.write('sessionStorage', 'pending', String(Date.now())));
      this.querySelector('[data-newsletter-copy]')?.addEventListener('click', async () => {
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(this.querySelector('[data-newsletter-code]').textContent.trim());
          status.textContent = 'Copied!';
        } catch (_) { status.textContent = 'Select the code above to copy it.'; }
      });
      this.editorSelect = event => { if (event.detail.sectionId === this.dataset.sectionId) this.open(); };
      document.addEventListener('shopify:section:select', this.editorSelect);
      const pending = Number(this.read('sessionStorage', 'pending'));
      const isReturn = (pending > 0 && Date.now() - pending < 30 * 60 * 1000) || window.location.hash === `#${this.form.id}`;
      if (isReturn && this.state !== 'idle') {
        if (this.state === 'success') {
          this.write('localStorage', 'subscribed', '1');
          this.write('sessionStorage', 'pending', '0');
        }
        this.open();
        return;
      }
      // Don't turn a footer newsletter submission into an unrelated popup.
      if (this.state !== 'idle' || this.dataset.subscribed === 'true' || this.read('localStorage', 'subscribed') || this.read('sessionStorage', 'dismissed')) return;
      if (window.Shopify?.designMode) return;
      let arrival = Number(this.read('sessionStorage', 'arrival'));
      if (!arrival) {
        arrival = Date.now();
        this.write('sessionStorage', 'arrival', String(arrival));
      }
      this.timer = window.setTimeout(() => this.open(), Math.max(0, Number(this.dataset.delay) - (Date.now() - arrival)));
    }
    read(storage, key) { try { return window[storage].getItem(`${this.key}:${key}`); } catch (_) { return null; } }
    write(storage, key, value) { try { window[storage].setItem(`${this.key}:${key}`, value); } catch (_) { /* Signup still works without browser storage. */ } }
    open() {
      if (!this.isConnected || this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add('momo-newsletter-open');
      // Heading focus avoids automatically opening the keyboard on mobile.
      this.querySelector('h2').focus({ preventScroll: true });
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('shopify:section:select', this.editorSelect);
      if (this.dialog?.open) this.dialog.close();
    }
  }
  customElements.define('momo-newsletter-popup', MomoNewsletterPopup);
})();
